import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Form,
  Table,
} from "react-bootstrap";
import LocationsMap from "./LocationMap";

const Locations = () => {
  const [lines, setLines] = useState({
    Green: [
      {
        id: 1,
        name: "Stop 1",
        latitude: 30.094742,
        longitude: 31.247279,
        order: 1,
      },
      {
        id: 2,
        name: "Stop 2",
        latitude: 30.094971,
        longitude: 31.25262,
        order: 2,
      },
      {
        id: 3,
        name: "Stop 2",
        latitude: 30.096319,
        longitude: 31.24757,
        order: 2,
      },
      {
        id: 4,
        name: "Stop 2",
        latitude: 30.09405,
        longitude: 31.24621,
        order: 2,
      },
    ],
    Red: [
      {
        id: 5,
        name: "Stop A",
        latitude: 30.095313,
        longitude: 31.251874,
        order: 1,
      },
      {
        id: 6,
        name: "Stop B",
        latitude: 30.094029,
        longitude: 31.251725,
        order: 2,
      },
    ],
    Blue: [
      {
        id: 5,
        name: "Stop X",
        latitude: 30.096276,
        longitude: 31.248535,
        order: 1,
      },
      {
        id: 6,
        name: "Stop Y",
        latitude: 30.091996,
        longitude: 31.246977,
        order: 2,
      },
    ],
  });

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("add"); // "add" or "edit"
  const [selectedLine, setSelectedLine] = useState("");
  const [currentStop, setCurrentStop] = useState({
    id: null,
    name: "",
    latitude: "",
    longitude: "",
    order: "",
  });

  const handleAddStop = (line) => {
    setModalType("add");
    setSelectedLine(line);
    setCurrentStop({
      id: null,
      name: "",
      latitude: "",
      longitude: "",
      order: "",
    });
    setShowModal(true);
  };

  const handleEditStop = (line, stop) => {
    setModalType("edit");
    setSelectedLine(line);
    setCurrentStop(stop);
    setShowModal(true);
  };

  const handleDeleteStop = (line, stopId) => {
    setLines((prevLines) => ({
      ...prevLines,
      [line]: prevLines[line].filter((s) => s.id !== stopId),
    }));
  };

  const handleSaveStop = () => {
    const updatedStop = {
      ...currentStop,
      id: currentStop.id || Date.now(), // Generate a unique ID for new stops
      latitude: parseFloat(currentStop.latitude),
      longitude: parseFloat(currentStop.longitude),
      order: parseInt(currentStop.order),
    };

    setLines((prevLines) => {
      const updatedLine =
        modalType === "add"
          ? [...prevLines[selectedLine], updatedStop]
          : prevLines[selectedLine].map((stop) =>
              stop.id === updatedStop.id ? updatedStop : stop
            );

      // Sort by order
      updatedLine.sort((a, b) => a.order - b.order);

      return { ...prevLines, [selectedLine]: updatedLine };
    });

    setShowModal(false);
  };

  return (
    <Container>
      <h1 className="text-center my-4">School Bus Pick-Up Locations</h1>
      <Row>
        {Object.keys(lines).map((line) => (
          <Col key={line} md={4}>
            <h2>{line} Line</h2>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {lines[line].map((stop, index) => (
                  <tr key={stop.id}>
                    <td>{stop.order}</td>
                    <td>
                      {stop.name} <br />
                      <small>
                        Lat: {stop.latitude}, Lng: {stop.longitude}
                      </small>
                    </td>
                    <td>
                      <Button
                        variant="warning"
                        size="sm"
                        className="me-2"
                        onClick={() => handleEditStop(line, stop)}
                      >
                        Edit
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleDeleteStop(line, stop.id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <Button
              variant="success"
              className="mt-3"
              onClick={() => handleAddStop(line)}
            >
              Add Stop
            </Button>
          </Col>
        ))}
      </Row>

      <LocationsMap busLines={lines} />

      {/* Modal for Adding/Editing Stops */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "add" ? "Add Stop" : "Edit Stop"} to {selectedLine}{" "}
            Line
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="stopName">
              <Form.Label>Stop Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter stop name"
                value={currentStop.name}
                onChange={(e) =>
                  setCurrentStop({ ...currentStop, name: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="latitude">
              <Form.Label>Latitude</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter latitude"
                value={currentStop.latitude}
                onChange={(e) =>
                  setCurrentStop({ ...currentStop, latitude: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="longitude">
              <Form.Label>Longitude</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter longitude"
                value={currentStop.longitude}
                onChange={(e) =>
                  setCurrentStop({ ...currentStop, longitude: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="order">
              <Form.Label>Order</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter stop order"
                value={currentStop.order}
                onChange={(e) =>
                  setCurrentStop({ ...currentStop, order: e.target.value })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveStop}>
            Save Stop
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Locations;
